import { EMilliSeconds } from 'modules/common/constants/const';
import { useAccount } from 'modules/account/hooks/useAccount';

import { useAccountStatusQuery } from '../actions/hooks/useAccountStatusQuery';

const pollingInterval = 30 * EMilliSeconds.Second;

export const useInitAccountStatus = () => {
  const { isWorkerAuthorized, userEndpointToken } = useAccount();

  useAccountStatusQuery({
    pollingInterval,
    skipFetching: !isWorkerAuthorized || !userEndpointToken,
    userEndpointToken: userEndpointToken!,
  });
};
